import { defineStore } from "pinia";
import { computed, ref } from "vue";

import type { Art } from "@/model/session";
import { useGlobalI18n } from "@/translations/i18n";
import { asReadonly } from "@/utils/vue";

import { useBoardsStore } from "./boards";

export const NO_ART = { id: "", name: "" };

const { t } = useGlobalI18n();

export const useArtStore = defineStore("art", () => {
  const arts = ref<Art[]>([]);
  const current = ref(NO_ART);

  const isMultiArt = computed(() => arts.value.length > 1);

  return {
    arts: asReadonly(arts),
    current: asReadonly(current),

    isMultiArt,
    noArt: computed(() => ({ id: NO_ART.id, name: t("general.noArt") })),

    artById: (artId?: Art["id"] | null) => arts.value.find((a) => a.id === artId),
    setArts: (artList: Art[]) => {
      arts.value = artList;
      current.value = NO_ART;
      useBoardsStore().updateObjectiveBoardId();
    },
    // this should only be called from team store
    setCurrent: (art: Art) => {
      current.value = art;
      useBoardsStore().updateObjectiveBoardId();
    },
    isCurrentArt: (artId?: string) => !isMultiArt.value || artId === current.value.id,
  };
});
